/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { TASK_TYPES } from 'volta/models/task';

import Component from '@glimmer/component';

import type { TTaskType, UTask } from 'volta/models/types/tasks';

export interface TasksKitFiltersSignature {
  Args: {
    tasks: UTask[];
    taskTypes?: TTaskType[];
    onTaskFilterChange: (taskTypes: TTaskType[]) => void;
    filterOptions: TTaskType[];
  };
  Element: HTMLElement;
}

export default class TasksKitFiltersComponent extends Component<TasksKitFiltersSignature> {
  get selectedFilters() {
    if (!this.args.taskTypes) {
      return [];
    }
    return TASK_TYPES.filter((type) => this.args.taskTypes!.includes(type));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::Filters': typeof TasksKitFiltersComponent;
    'tasks-kit/filters': typeof TasksKitFiltersComponent;
  }
}
